/* eslint-disable import/no-cycle */
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MobileStepper from "@mui/material/MobileStepper";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import * as React from "react";
import "./index.css";
import * as yup from "yup";
import { OrganizationInfoType } from "types/company";
import API from "@/api/serverCall";
import getOrganizationInfoRequestThunk from "@/redux/organization/thunk";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

interface OrganizationNameProps {
	activeStep: number;
	setActiveStep: (value: number) => void;
}

const OrganizationName: React.FC<OrganizationNameProps> = ({
	setActiveStep,
	activeStep,
}) => {
	const dispatch = useDispatch();
	const { i18n } = useTranslation();
	let validationSchema;
	if (i18n.language === "ko") {
		validationSchema = yup.object({
			OrganizationName: yup
				.string()
				.trim()
				.required("사용하실 단체명을 입력해주세요"),
			OrganizationPhoneNumber: yup
				.string()
				.min(9, "너무 짧습니다!")
				.max(20, "너무 깁니다!")
				.required("대표로 사용할 연락처를 입력해주세요"),
		});
	} else {
		validationSchema = yup.object({
			OrganizationName: yup
				.string()
				.trim()
				.required("Please enter the organization name you would like to use."),
			OrganizationPhoneNumber: yup
				.string()
				.min(9, "너무 짧습니다!")
				.max(20, "너무 깁니다!")
				.required("대표로 사용할 연락처를 입력해주세요"),
		});
	}
	const registOrganizationName = (
		organizationName: string,
		OrganizationPhoneNumber: string,
	) => {
		// for loading
		try {
			const requestData = {
				email: "",
				name: organizationName,
				phone: OrganizationPhoneNumber,
			};
			API.PATCH<OrganizationInfoType>({
				link: `/company`,
				body: requestData,
			}).then((response) => {
				if (!isEmpty(response.data)) {
					dispatch(getOrganizationInfoRequestThunk());
					setActiveStep(activeStep + 1);
				}
			});
		} catch (error) {
			console.error(error);
		}
	};
	const formik = useFormik({
		initialValues: {
			OrganizationName: "",
			OrganizationPhoneNumber: "",
		},
		validationSchema,
		onSubmit: (values) => {
			registOrganizationName(
				values.OrganizationName,
				values.OrganizationPhoneNumber,
			);
		},
	});

	return (
		<>
			<form onSubmit={formik.handleSubmit}>
				<DialogTitle
					sx={{
						display: "flex",
						alignItems: "center",
						flexDirection: "column",
					}}
				>
					<div
						style={{
							fontSize: "3rem",
							position: "relative",
							right: "0.5rem",
						}}
					>
						👋
					</div>
					<Typography
						sx={{
							fontSize: "2rem",
							fontWeight: "bold",
						}}
					>
						{i18n.language === "ko" ? "환영합니다" : "Welcome!"}
					</Typography>
				</DialogTitle>

				<DialogContent sx={{ padding: "5rem 3rem" }}>
					<div style={{ marginTop: "3rem" }}>
						<Typography>
							{i18n.language === "ko" ? "단체명" : "Group Name"}
						</Typography>
						<TextField
							variant="outlined"
							size="medium"
							fullWidth={true}
							id="OrganizationName"
							name="OrganizationName"
							placeholder={
								i18n.language === "ko"
									? "사용하실 단체명을 입력해주세요."
									: "Please enter the organization name you would like to use."
							}
							value={formik.values.OrganizationName}
							onChange={formik.handleChange}
							error={
								formik.touched.OrganizationName &&
								Boolean(formik.errors.OrganizationName)
							}
							helperText={
								formik.touched.OrganizationName &&
								formik.errors.OrganizationName
							}
						/>
					</div>
					<div style={{ marginTop: "1rem" }}>
						<Typography>
							{i18n.language === "ko" ? "대표번호" : "Phone Number"}
						</Typography>
						<TextField
							variant="outlined"
							size="medium"
							fullWidth={true}
							id="OrganizationPhoneNumber"
							name="OrganizationPhoneNumber"
							type="number"
							placeholder={
								i18n.language === "ko"
									? "대표로 사용할 연락처를 입력해주세요"
									: "Please enter the contact information you want to use"
							}
							value={formik.values.OrganizationPhoneNumber}
							onChange={formik.handleChange}
							error={
								formik.touched.OrganizationPhoneNumber &&
								Boolean(formik.errors.OrganizationPhoneNumber)
							}
							helperText={
								i18n.language === "ko"
									? " - 없이 번호를 입력해주세요 (9자 ~ 20자)"
									: "- Please enter the number without any (9 to 20 characters)"
							}
						/>
					</div>
				</DialogContent>
				<div
					style={{
						width: "57%",
						marginLeft: "auto",
						marginBottom: "2rem",
					}}
				>
					<MobileStepper
						variant="dots"
						steps={2}
						position="static"
						activeStep={activeStep}
						sx={{
							maxWidth: 400,
							flexGrow: 1,
							marginLeft: "1rem",
						}}
						nextButton={
							<Button
								size="small"
								type="submit"
								style={{
									backgroundColor: "#2453F9",
									color: "white",
									marginRight: "1rem",
									height: "2.5rem",
								}}
							>
								{i18n.language === "ko" ? "다음" : "Next"}
							</Button>
						}
						backButton={false}
					/>
				</div>
			</form>
		</>
	);
};
export default OrganizationName;
